import * as types from "../actions/actionTypes";
const initialState = {
  loading: true,
  data: [],
  last_item: ""
};

const Dashboard = (state = initialState, action) => {
  switch (action.type) {
    case types.DASHBOARD_LIST_REQUEST:
      return { ...state, loading: true };
    case types.DASHBOARD_LIST_SUCCESS:
      return { ...state, ...action.payLoad };
    case types.DASHBOARD_LIST_FAILURE:
      return { ...state, ...action.payLoad };
    default:
      return state;
  }
};

export default Dashboard;
